module.exports = __webpack_public_path__ + "img/register_bg_mobile.e5df91b5.png";